import { RESOURCES } from "@/organisms/Form"
import { getAssetsScope } from "./getDemoData"

import type { AiPolicyFormValues } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/AiPolicyForm/AiPolicyForm.types"
import type { ScopeRecord } from "./getDemoData.types"

const ALL_AGENTS_SCOPE = "All agents"

const getResourceLabel = (type: string, values: string[]) => {
  const option = getAssetsScope().find((item) => item.id === type)
  const labels = values.map(
    (value) =>
      option?.opts.find((opt) => opt.id === value)?.displayName ?? value
  )

  return `${option?.displayName ?? type}: ${labels.join(", ")}`
}

const getScopeName = (values: AiPolicyFormValues) => {
  if (values.resources !== RESOURCES.SPECIFIC) return ALL_AGENTS_SCOPE

  const parts = (values.specific_resources ?? []).flatMap((resource) => {
    const selected = [resource.value ?? []].flat().filter(Boolean)

    return resource.type && selected.length > 0
      ? [getResourceLabel(resource.type, selected)]
      : []
  })

  return parts.length > 0 ? parts.join(" · ") : ALL_AGENTS_SCOPE
}

// Shell for a policy created by hand on the AI Policies page; the provider
// fills name, description, rules and the covered agents.
export const createScopeRecord = (
  values: AiPolicyFormValues,
  id: string
): ScopeRecord => ({
  id,
  key: id,
  scopeId: id,
  type: "scope",
  name: getScopeName(values),
  count: 0,
  total: 0,
  overrides: "",
  description: "",
  expandable: false,
  agents: [],
  policyId: id,
  policyName: values.name_details,
  policyDescription: values.description_details ?? "",
  violated: false,
  agentsDescription: "",
  allowed: [],
  notAllowed: []
})
